export default __webpack_public_path__ + "static/media/livro-de-reclamacoes.b3147593.svg";